module.exports = __webpack_public_path__ + "static/media/Demographic_options_black.6d659d40.svg";